export enum RubroEnum {
    Vida = 1,
    AP,
    OtrosRubros,
    Ajustes
}